module.exports = __webpack_public_path__ + "img/hr-car-mask-1.f97ac474.png";